import {
    SECONDARY_SIDEBAR_COLLAPSED_WIDTH,
    SECONDARY_SIDEBAR_WIDTH,
} from '@/common/constants/constants';
import { useSecondarySidebarStore } from '@/common/stores/secondarySidebarStore';
import { useSubscribeToUnreadReports } from '@/features/performance/report/shared/hooks/useReportStreaming';
// import { useSubscribeToUnreadFeedback } from '@/features/performance/feedback/hooks/useSubscribeToUnreadFeedback';
import {
    CreateWorkspaceDialog,
    useCurrentWorkspace,
    WorkspaceCreationButton,
    WorkspaceItem,
} from '@/features/workspace';
import { useMyWorkspaces } from '@/features/workspace/services';
import { useAuthStore } from '@/stores/authStore';
import { Stack, useMantineTheme } from '@mantine/core';
import { useState } from 'react';

const SecondarySidebar = () => {
    const { user } = useAuthStore();
    const theme = useMantineTheme();

    // React Query로 워크스페이스 데이터 관리
    const {
        data: workspaces = [],
        isLoading: workspacesLoading,
        error: workspacesError,
        refetch: refetchWorkspaces,
    } = useMyWorkspaces();

    // 워크스페이스 생성 다이얼로그 상태 관리
    const [createWorkspaceDialogOpened, setCreateWorkspaceDialogOpened] =
        useState(false);

    // 현재 워크스페이스 상태 관리 (localStorage 기반)
    const { currentWorkspace } = useCurrentWorkspace(user?.id);

    // 안 읽은 보고서 실시간 구독 시작 (개인 보고서만)
    useSubscribeToUnreadReports(user?.id, currentWorkspace?.id);
    // 팀 보고서(피드백) 구독 임시 비활성화
    // useSubscribeToUnreadFeedback(user?.id, currentWorkspace?.id);

    // SecondarySidebar 접기/펴기 상태 관리
    const { isExpanded } = useSecondarySidebarStore();

    // 워크스페이스 생성 다이얼로그 닫기 핸들러
    const handleCreateWorkspaceClose = () => {
        setCreateWorkspaceDialogOpened(false);
        void refetchWorkspaces();
    };

    return (
        <div
            style={{
                width: isExpanded
                    ? SECONDARY_SIDEBAR_WIDTH
                    : SECONDARY_SIDEBAR_COLLAPSED_WIDTH,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                transition: 'width 0.3s ease',
                backgroundColor: theme.colors.gray[0],
            }}
        >
            {/* 워크스페이스 목록 영역 */}
            <Stack
                gap={4}
                align={isExpanded ? 'start' : 'center'}
                style={{ flex: '1 1 auto', overflow: 'hidden' }}
            >
                {workspaces.length > 0 ? (
                    <div
                        style={{
                            width: '100%',
                            flex: '1 1 auto',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            // 스크롤바 스타일링 (Webkit 브라우저용)
                            scrollbarWidth: isExpanded ? 'thin' : 'none',
                            scrollbarColor:
                                'var(--mantine-color-gray-4) transparent',
                        }}
                    >
                        <Stack>
                            {/* 현재 선택된 워크스페이스 또는 첫 번째 워크스페이스 표시 */}
                            <WorkspaceItem
                                key={currentWorkspace?.id || workspaces[0].id}
                                workspace={currentWorkspace || workspaces[0]}
                            />
                        </Stack>
                    </div>
                ) : (
                    <WorkspaceCreationButton
                        onCreateWorkspace={() =>
                            setCreateWorkspaceDialogOpened(true)
                        }
                    />
                )}
            </Stack>

            <CreateWorkspaceDialog
                opened={createWorkspaceDialogOpened}
                onClose={handleCreateWorkspaceClose}
            />
        </div>
    );
};

export default SecondarySidebar;
